import { Observable } from 'rxjs';
import { 
    RequestDownloadExcelDto, 
    RequestDownloadPdfDto, 
    RequestSendEmailExcelDto, ResponseSendEmailExcelDto, 
    RequestSendEmailPdfDto, ResponseSendEmailPdfDto 
} from './../dto/employee-request-report.dto';
import { NestApiProvider } from './../../nest-api';
import { Injectable } from "@angular/core";




@Injectable()
export class EmployeeRequestReportApi{
    private service: string ='';
    private model: string ='ViewEmpReq'
    
    constructor(
        private nestApiProvider: NestApiProvider
    ){}

    downloadExcel(data:RequestDownloadExcelDto){
        const method: string = 'POST';
        const func: string = 'downloadExcel';
        const params: RequestDownloadExcelDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams,body)
    }

    downloadPdf(data:RequestDownloadPdfDto){
        const method: string = 'POST';
        const func: string = 'downloadPdf';
        const params: RequestDownloadPdfDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams,body)
    }

    reportSendEmailExcel(data:RequestSendEmailExcelDto): Observable<ResponseSendEmailExcelDto>{
        const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: RequestSendEmailExcelDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseSendEmailExcelDto>(method, url, params, urlParams,body)
    }

    reportSendEmailPdf(data:RequestSendEmailPdfDto): Observable<ResponseSendEmailPdfDto>{
        const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: RequestSendEmailPdfDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseSendEmailPdfDto>(method, url, params, urlParams,body)
    }




}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/employee-request-report.api.ts